import React from 'react';
import style from './style.scss'

const Input = (props) => {
    const {field,type="text"} = props;
    return (
        <div>
            <label
                htmlFor={field.elementId}
                className={style.formLabel}
            >
                {field.label} {field.required&&<span className={style.asterisk}> *</span>}
            </label>
            <input
                autoComplete={field.name}
                className={style.fieldInput}
                id={field.elementId}
                type={type}
                value={field.value}
                placeholder={field.placeholder}
            />
        </div>
    )
}

export default Input;
